var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"Breadcrumb breadcrumb"},_vm._l((_vm.links),function(link,index){return _c('li',{key:index,class:("breadcrumb-item" + (link.active ? ' active' : ''))},[(link.path)?_c('router-link',{attrs:{"to":{ path: ("/" + (link.path)) }}},[_vm._v(_vm._s(link.name))]):_c('span',[_vm._v(_vm._s(link.name))])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-755230b4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcrumb/breadcrumb.vue
// module id = null
// module chunks = 